import { createAction } from '@reduxjs/toolkit';
import { AuthCredentials, User, RegisterPayload as ServiceRegisterPayload } from '../../services/authService';

// Payload types
export type LoginPayload = AuthCredentials;
export type RegisterPayload = ServiceRegisterPayload;

// Trigger authentication status check
export const checkAuthRequest = createAction<void>('auth/checkAuthRequest');
export const checkAuthSuccess = createAction<User | null>('auth/checkAuthSuccess');
export const checkAuthFailure = createAction<string>('auth/checkAuthFailure');

// Trigger login
export const loginRequest = createAction<LoginPayload>('auth/loginRequest');
export const loginSuccess = createAction<User>('auth/loginSuccess');
export const loginFailure = createAction<string>('auth/loginFailure');

// Trigger registration
export const registerRequest = createAction<RegisterPayload>('auth/registerRequest');
export const registerSuccess = createAction<User>('auth/registerSuccess');
export const registerFailure = createAction<string>('auth/registerFailure');

// Trigger logout
export const logoutRequest = createAction<void>('auth/logoutRequest');
export const logoutSuccess = createAction<void>('auth/logoutSuccess');
export const logoutFailure = createAction<string>('auth/logoutFailure');

// Trigger session expiry
export const sessionExpired = createAction<void>('auth/sessionExpired');